//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'FormCheckbox',

	model: {
		prop: 'checked',
		event: 'change'
	},

	props: {
		label: {
			type: String
		},

		required: {
			type: Boolean,
			default: false
		},

		name: {
			type: String,
			default: ''
		},

		checked: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		onChange: function onChange(e) {
			this.$emit('change', e.target.checked);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormCheckbox.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormCheckbox.vue
// module chunks = 0 1 2